Specific contact people for the position opening at the party.

The name, email address & role of at least one contact person must be provided.
A maximum of 10 contact people may be provided.
